import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { SStrapiService, useCmsLocaleReload } from '@slg/web-customer-shared';
import TwoColumnInfo from '@/components/strapi/TwoColumnInfo.vue';
import AdditionalInfo from '@/components/strapi/AdditionalInfo.vue';
import TryOurApp from '@/components/strapi/TryOurApp.vue';
import BookingForm from '@/components/bookingForm/BookingForm.vue';
import BookingBg from '@/components/bookingForm/BookingBg.vue';
import { useGtm } from '@/composables';


import { getMetaInfo } from '@/utils/seo';

const __default__ = {
  name: 'BookingPage',
  metaInfo() {
    return getMetaInfo((this as { homePageData?: { Seo?: unknown } }).homePageData?.Seo);
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { trackGtmEvent } = useGtm();
const homePageData = ref<Record<string, any> | null>(null);

async function getHomePageData() {
  homePageData.value = await SStrapiService.getHomePage();
}

async function loadCmsData() {
  try {
    await getHomePageData();
  } catch (e) {
    // to-do rethink about catch
  }
}

useCmsLocaleReload(loadCmsData);

onMounted(() => {
  trackGtmEvent('Booking page', 'Page', 'Loaded', 'Booking page is loaded');
});

return { __sfc: true,trackGtmEvent, homePageData, getHomePageData, loadCmsData, TwoColumnInfo, AdditionalInfo, TryOurApp, BookingForm, BookingBg }
}

})